import { ModulockerSet } from './interfaces/ModulockerSet';

export const initialState: ModulockerSet = {
  description: '',
  modQty: 0,
  modules: [] as Array<string>,
  sku: '',
  status: '',
  totalBoxes: 0,
}